export default __webpack_public_path__ + "static/media/front.253e4d1d.png";